(() => {
  "use strict";

  if (window.wolfWarrantyProductPopupInitialized) return;
  window.wolfWarrantyProductPopupInitialized = true;

  const popup = document.querySelector("[data-warranty-product-popup]");

  const eligibleVariantIds = new Set(
    String(popup?.dataset.warrantyVariantIds || "")
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean)
  );

  let addInProgress = false;

  function getShopifyRoot() {
    return window.Shopify?.routes?.root || "/";
  }

  function openPopup() {
    if (!popup) return;

    popup.hidden = false;
    popup.setAttribute("aria-hidden", "false");

    document.documentElement.classList.add("wolf-warranty-popup-open");

    const closeButton = popup.querySelector(".wolf-warranty-popup__close");

    if (closeButton) {
      window.setTimeout(() => closeButton.focus(), 50);
    }
  }

  function closePopup() {
    if (!popup) return;

    popup.hidden = true;
    popup.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove("wolf-warranty-popup-open");
  }

  if (popup) {
    popup.addEventListener("click", (event) => {
      if (!(event.target instanceof Element)) return;

      const closeControl = event.target.closest("[data-warranty-popup-close]");
      if (!closeControl) return;

      event.preventDefault();
      closePopup();
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && popup && !popup.hidden) {
      closePopup();
    }
  });

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      let formUrl;

      try {
        formUrl = new URL(form.action, window.location.origin);
      } catch (error) {
        return;
      }

      if (!/\/cart\/add(\.js)?\/?$/.test(formUrl.pathname)) return;
      if (!window.location.pathname.includes("/products/")) return;

      const formData = new FormData(form);
      const variantId = String(formData.get("id") || "").trim();

      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (addInProgress) return;
      addInProgress = true;

      const submitButton =
        event.submitter instanceof HTMLElement
          ? event.submitter
          : form.querySelector('[type="submit"]');

      const originalButtonText = submitButton?.textContent || "";

      if (submitButton) {
        submitButton.setAttribute("disabled", "disabled");
        submitButton.textContent = "Adding…";
      }

      try {
/*
 * Check available stock against the quantity
 * already in the cart before adding more.
 */
const stockLimit =
  window.wolfProductStockLimits?.[variantId];

if (stockLimit?.limited) {
  const requestedQuantity = Number(
    formData.get("quantity") ?? 1
  );

  if (
    !Number.isInteger(requestedQuantity) ||
    requestedQuantity < 1
  ) {
    throw new Error("Please enter a valid quantity.");
  }

  const cartResponse = await fetch(
    `${getShopifyRoot()}cart.js`,
    {
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        Accept: "application/json"
      }
    }
  );

  if (!cartResponse.ok) {
    throw new Error(
      "We couldn't check your cart. Please try again."
    );
  }

  const currentCart = await cartResponse.json();

  const alreadyInCart = currentCart.items.reduce(
    (total, item) => {
      return String(item.variant_id) === variantId
        ? total + item.quantity
        : total;
    },
    0
  );

  const availableStock = Math.max(
    0,
    Number(stockLimit.quantity)
  );

  const remaining = Math.max(
    0,
    availableStock - alreadyInCart
  );

  if (requestedQuantity > remaining) {
    if (remaining === 0 && alreadyInCart > 0) {
      throw new Error(
        "You already have all available stock of this item in your cart."
      );
    }

    if (remaining === 0) {
      throw new Error(
        "This item is currently out of stock."
      );
    }

    throw new Error(
      `You can add only ${remaining} more ${
        remaining === 1 ? "item" : "items"
      } to your cart.`
    );
  }
}

const response = await fetch(`${getShopifyRoot()}cart/add.js`, {
  method: "POST",
  credentials: "same-origin",
  headers: {
    Accept: "application/json"
  },
  body: formData
});

        let result = {};

        try {
          result = await response.json();
        } catch (error) {
          console.warn("Add-to-cart response was not JSON:", error);
        }

        if (!response.ok) {
          throw new Error(
            result.description ||
              result.message ||
              "This item could not be added to your cart."
          );
        }

        // Notify the separate counter and the theme.
        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              source: "wolf-ajax-add"
            }
          })
        );

        if (eligibleVariantIds.has(variantId)) {
          openPopup();
        }
      } catch (error) {
        console.error("Product add error:", error);

        alert(
          error instanceof Error
            ? error.message
            : "This item could not be added to your cart."
        );
      } finally {
        addInProgress = false;

        if (submitButton) {
          submitButton.removeAttribute("disabled");

          if (originalButtonText) {
            submitButton.textContent = originalButtonText;
          }
        }
      }
    },
    true
  );
})();